/// <reference types="vite/client" />
import { createClient } from '@supabase/supabase-js'

const supabaseUrl = (import.meta as any).env?.VITE_SUPABASE_URL || 'https://izppuhyrdaobjwcgnyhi.supabase.co'
const supabaseAnonKey = (import.meta as any).env?.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Iml6cHB1aHlyZGFvYmp3Y2dueWhpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzY0NTA0NDIsImV4cCI6MjA5MjAyNjQ0Mn0.MjI-gBxcxvhhpFgpHT3_etCcKPJBeSE8DSLo9D87CCY'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)
